import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "logo-and-hamburger-wrapper" }
const _hoisted_2 = {
  key: 0,
  style: {"color":"#fff"}
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = {
  key: 0,
  class: "link-text heading-6"
}
const _hoisted_6 = {
  key: 1,
  class: "unread-counter"
}
const _hoisted_7 = {
  key: 0,
  class: "request-wrapper"
}
const _hoisted_8 = {
  key: 1,
  class: "request-wrapper"
}
const _hoisted_9 = {
  key: 2,
  class: "request-wrapper"
}
const _hoisted_10 = {
  key: 3,
  class: "request-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NewDocumentSvg = _resolveComponent("NewDocumentSvg")!
  const _component_menu_link = _resolveComponent("menu-link")!
  const _component_EmsDocumentSvg = _resolveComponent("EmsDocumentSvg")!
  const _component_ArchiveSvg = _resolveComponent("ArchiveSvg")!
  const _component_ReportSvg = _resolveComponent("ReportSvg")!
  const _component_UploadSvg = _resolveComponent("UploadSvg")!
  const _component_RequestPartnerSvg = _resolveComponent("RequestPartnerSvg")!
  const _component_SettingSvg = _resolveComponent("SettingSvg")!
  const _component_ChatSvg = _resolveComponent("ChatSvg")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sidebar", { opened: _ctx.isOpened }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isOpened)
        ? (_openBlock(), _createElementBlock("h5", _hoisted_2, "Dashboard"))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass({
            'close-sidebar-menu ': true,
            'close-sidebar-menu-closed': !_ctx.isOpened,
          }),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onToggleSidebar'))),
        onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('onToggleSidebar')), ["enter"]))
      }, [
        _createElementVNode("img", {
          src: require('@/assets/header-back.png'),
          alt: "hamburger"
        }, null, 8, _hoisted_3)
      ], 34)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.resetSearchValue && _ctx.resetSearchValue(...args)))
      }, [
        _createVNode(_component_menu_link, {
          text: "EPX Engagements",
          url: "/",
          "is-opened": _ctx.isOpened
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_NewDocumentSvg)
          ]),
          _: 1
        }, 8, ["is-opened"])
      ]),
      _createElementVNode("div", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetSearchValue && _ctx.resetSearchValue(...args)))
      }, [
        _createVNode(_component_menu_link, {
          text: "EMS Engagements",
          url: "/ems-dashboard",
          "is-opened": _ctx.isOpened
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_EmsDocumentSvg)
          ]),
          _: 1
        }, 8, ["is-opened"])
      ]),
      _createVNode(_component_menu_link, {
        text: "Archives",
        url: "/archive",
        "is-opened": _ctx.isOpened
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_ArchiveSvg)
        ]),
        _: 1
      }, 8, ["is-opened"]),
      _createVNode(_component_menu_link, {
        text: "Report Dashboard",
        url: "/report",
        "is-opened": _ctx.isOpened
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_ReportSvg)
        ]),
        _: 1
      }, 8, ["is-opened"]),
      _createVNode(_component_menu_link, {
        text: "Bulk Behaviors",
        url: "/upload",
        "is-opened": _ctx.isOpened
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_UploadSvg)
        ]),
        _: 1
      }, 8, ["is-opened"]),
      _createElementVNode("div", {
        class: "menu-link",
        style: {"cursor":"pointer"},
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleCBPPartnerMenuClick && _ctx.handleCBPPartnerMenuClick(...args)))
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_RequestPartnerSvg)
        ]),
        (_ctx.isOpened)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Request to CBP/Partner"))
          : _createCommentVNode("", true),
        (_ctx.unreadRequestToPartnerCount)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.unreadRequestToPartnerCount), 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.isOpenedRequestToCbpPartnerMenu && _ctx.isOpened)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_menu_link, {
              class: "mb-0",
              text: "Send a Request",
              url: "/request-partner",
              "is-opened": _ctx.isOpened
            }, {
              icon: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  class: "lucide lucide-send h-4 w-4 shrink-0",
                  "aria-hidden": "true"
                }, [
                  _createElementVNode("path", { d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z" }),
                  _createElementVNode("path", { d: "m21.854 2.147-10.94 10.939" })
                ], -1)
              ]))]),
              _: 1
            }, 8, ["is-opened"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isOpenedRequestToCbpPartnerMenu && _ctx.isOpened)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_menu_link, {
              class: "mb-0",
              text: "Review Request",
              url: "/review-request",
              "is-opened": _ctx.isOpened
            }, {
              icon: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  class: "lucide lucide-eye h-3.5 w-3.5 shrink-0",
                  "aria-hidden": "true"
                }, [
                  _createElementVNode("path", { d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" }),
                  _createElementVNode("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3"
                  })
                ], -1)
              ]))]),
              _: 1
            }, 8, ["is-opened"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isOpenedRequestToCbpPartnerMenu && _ctx.isOpened)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_menu_link, {
              class: "mb-0",
              text: "Request Sent",
              url: "/request-sent",
              "is-opened": _ctx.isOpened
            }, {
              icon: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  class: "lucide lucide-mail h-3.5 w-3.5 shrink-0",
                  "aria-hidden": "true"
                }, [
                  _createElementVNode("path", { d: "m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" }),
                  _createElementVNode("rect", {
                    x: "2",
                    y: "4",
                    width: "20",
                    height: "16",
                    rx: "2"
                  })
                ], -1)
              ]))]),
              _: 1
            }, 8, ["is-opened"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isOpenedRequestToCbpPartnerMenu && _ctx.isOpened)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_menu_link, {
              class: "mb-0",
              text: "Approved Request",
              url: "/request-approved",
              "is-opened": _ctx.isOpened
            }, {
              icon: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  class: "lucide lucide-circle-check-big h-3.5 w-3.5 shrink-0",
                  "aria-hidden": "true"
                }, [
                  _createElementVNode("path", { d: "M21.801 10A10 10 0 1 1 17 3.335" }),
                  _createElementVNode("path", { d: "m9 11 3 3L22 4" })
                ], -1)
              ]))]),
              _: 1
            }, 8, ["is-opened"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_menu_link, {
        text: "Settings",
        url: "/app-config",
        "is-opened": _ctx.isOpened
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_SettingSvg)
        ]),
        _: 1
      }, 8, ["is-opened"]),
      _createVNode(_component_menu_link, {
        text: "Chat",
        url: "/chat",
        "is-opened": _ctx.isOpened
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_ChatSvg)
        ]),
        _: 1
      }, 8, ["is-opened"]),
      (_ctx.isLogInEnabled && _ctx.isOpened)
        ? (_openBlock(), _createElementBlock("a", {
            key: 4,
            class: "log-out-button",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
          }, "Log Out"))
        : _createCommentVNode("", true)
    ])
  ], 2))
}